module.exports = __webpack_public_path__ + "img/stock6.a63b3f4b.png";